export function truncateString(str: string, limit: number): string {
    if (str.length <= limit) {
        return str;
    }

    return str.slice(0, limit / 2) + '...' + str.slice(str.length - limit / 2);
}